import { gql } from '@parkchirp/api-client';

export const LIST_BILLING_PROFILES = gql`
    query listBillingProfiles(
        $limit: Int,
        $offset: Int,
        $filters: [Filter],
        $order: Order,
    ) {
        listBillingProfiles(
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
        ) {
            billing_profiles {
                id
                name
                active
                validation_only
                rates {
                    id
                    name
                }
            }
        }
    }
`;

export const LIST_RATES_FOR_BULK_UPLOAD = gql`
    query listRatesForBulkUpload(
        $billingProfileIds: [String]
        $facilityId: String!
    ) {
        listRatesForBulkUpload(
            billingProfileIds: $billingProfileIds
            facilityId: $facilityId
        ) {
            rates {
                id
                name
                active
                inactiveDate
                requireCarInfo
                isDefault
                isSoldOut
                billingProfile {
                    id
                    name
                }
                accessDevices {
                    id
                    type
                }
                fees {
                    id
                    type
                    startDate
                }
                childRateMetadata {
                    startDate
                    endDate
                }
            }
        }
    }
`;

export const GET_BILLING_PROFILES_SUBSCRIPTIONS = gql`
    query getBillingProfilesSubscriptions(
        $facilityId: String!
        $billingProfileIds: [String!]!
    ) {
        getBillingProfilesSubscriptions(
            facilityId: $facilityId
            billingProfileIds: $billingProfileIds
        ) {
            billingProfileId
            subscriptions {
                accountId
                subscriptionName
            }
        }
    }
`;

export const VALIDATE_BULK_UPLOAD_MONTHLY_FEE = gql`
    query validateBulkUploadMonthlyFee($parkerRates: [BulkUploadParkerRate]) {
        validateBulkUploadMonthlyFee(parkerRates: $parkerRates) {
            invalidRates
        }
    }
`;

export const CREATE_BULK_UPLOAD = gql`
    mutation createBulkUpload(
        $batchId: String!,
        $parkersOnly: Boolean!,
        $subscriptionMappingId: String!,
        $parkers: [ParkerInput]!,
        $subscription: SubscriptionInput,
        $payor: PayorInput,
    ) {
        createBulkUpload(
            batchId: $batchId,
            parkersOnly: $parkersOnly,
            payor: $payor,
            subscriptionMappingId: $subscriptionMappingId,
            subscription: $subscription,
            parkers: $parkers,
        ) {
            batchId
        }
    }
`;

export const BULK_UPLOAD_PROGRESS = gql`
    query bulkUploadProgress($batchId: String!) {
        bulkUploadProgress(batchId: $batchId) {
            new
            processing
            success
            failed
        }
    }
`;

export const LIST_SUBSCRIPTIONS = gql`
    query listSubscriptions($filters: [Filter]) {
        listSubscriptions(
            filters: $filters
        ) {
            total
            offset
            subscriptions {
                id
                account_id
                subscription_name
                billing_profile {
                    id
                    name
                    rates {
                        id
                        name
                    }
                }
            }
        }
    }
`;

export const CREATE_BULK_FEE_CHANGE = gql`
    mutation createBulkFeeChange(
        $s3Key: String!
    ) {
        createBulkFeeChange (
            s3Key: $s3Key
        ) {
            successfulFees,
            unsuccessfulFees,
            unsuccessfulCSVUrl,
        }
    }
`;

export const GET_PUT_SIGNED_URL = gql`
    query getPutSignedUrl(
        $bucket: String!,
        $s3Key: String!
    ) {
        getPutSignedUrl (
            bucket: $bucket,
            s3Key: $s3Key
        ) {
            url
        }
    }
`;
